import React from "react";

/**
 * @typedef {import("../../../jsdoc/ExistingContract.js").ExistingContract} ExistingContract
 */

/**
 * @param {Object} props
 * @param {ExistingContract} props.contact
 * @param {boolean} props.primary
 * @returns {React.JSX.Element}
 */
export default function Contact({ contact, primary }) {
  return (
    <tr role="row">
      <td role="gridcell" headers="row-head name-head">{`${contact.firstName} ${contact.lastName}${
        primary ? " (Primary)" : ""
      }`}</td>
      <td role="gridcell" headers="row-head email-head">
        {contact.email}
      </td>
      <td role="gridcell" headers="row-head phone-head">
        {contact.phone}
      </td>
    </tr>
  );
}
